import React from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Icon, Form, Dropdown, Table, Popup, Loader
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';


// import styled, { keyframes } from 'styled-components';
// import { fadeIn } from 'react-animations';
import { Link, Redirect, Route } from 'react-router-dom';
import ActivePollList from '../AdminPoll/PollTabs/ActivePollList';
import moment from 'moment';
import CourseListProfessors from './CourseList';

import SearchTableData from '../../util/SearchTableData';
import ReactExport from 'react-data-export';
import PaginationFront from '../../util/PaginationFront';
import { sanitizeExcelDataSet } from '../../util/sanitizeExcel';

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;
const { ExcelColumn } = ReactExport.ExcelFile;


export default class PollList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            pollList: [],
            results: [],

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

            excelData: []

        };

        this.getResults = this.getResults.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
    }
    componentDidMount() {
        localStorage.removeItem('courseId');
        localStorage.removeItem('spId');
        localStorage.removeItem('poll');
        localStorage.removeItem('organizationalUnitEmployeeId');
        localStorage.removeItem('courseImplementationGroupId');
        axios.get('questionnaire/staff/3/')
            .then(res => {
                const reverseList = res.data.reverse();
                this.setState({
                    pollList: reverseList.map(el => ({
                        ...el,
                        activationDate: el.activationDate ? moment(el.activationDate).format('D. M. YYYY.') : '',
                        endDate: el.endDate ? moment(el.endDate).format('D. M. YYYY.') : '',
                    })),
                    loading: false,
                },
                ()=>{
                    this.setState({
                excelData:  this.state.pollList.map((el, index) => ([
                    { value: (index + 1) + '.'},
                    { value: el.name},
                    { value: el.questionnaireType.name},
                    { value: el.activationDate},
                    { value: el.endDate}
                ]))})
                });
            })
            .catch(err => {
                console.log('Failed to fetch poll statuses.');
            });
    }

    // componentWillMount() {
    //
    //     axios.get('/questionnaire/get-statuses/')
    //         .then(res => {
    //             const statuses = res.data.map(el => ({
    //                 value: el.id,
    //                 key: el._key,
    //                 text: el.name
    //             }));
    //             this.setState({ statuses, loader: true });
    //         })
    //         .catch(err => {
    //             console.log('Failed to fetch poll statuses.');
    //         });
    // }


    getDataToRender() {
        // if (this.state.showFiltersOnButton) {
        //     return this.state.filterData;
        // }
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.pollList;
    }

    getResults(results) {
        if(results.length === 0)
        {
            this.setState({
                results: [],
                excelData: this.state.pollList.map((el, index) => ([
                    { value: (index + 1) + '.'},
                    { value: el.name},
                    { value: el.questionnaireType.name},
                    { value: el.activationDate},
                    { value: el.endDate}

                ]))});
        }
        else {
            this.setState({ results,
                excelData:  results.map((el, index) => ([
                    { value: (index + 1) + '.'},
                    { value: el.name},
                    { value: el.questionnaireType.name},
                    { value: el.activationDate},
                    { value: el.endDate}

                ]))});
        }
        this.handlePaginationChange({}, {activePage: 1})
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })

    render() {
        // const FadeIn = styled.div`animation: 1s ${keyframes`${fadeIn}`}`;
        if (this.state.showResults === true) {
            return (<FormattedMessage id="route.pollCourses">
                {(msg) => (<Redirect push to={{ pathname: msg }} />)}
            </FormattedMessage>);
        }
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        const multiDataSet = [
            {
                columns: [
                    { title: 'R. br.', width: { wpx: 50 } },
                    { title: 'Naziv', width: { wpx: 700 } },
                    { title: 'Tip', width: { wpx: 200 } },
                    { title: 'Datum objave studentima', width: { wpx: 200 } },
                    { title: 'Datum isteka', width: { wpx: 200 } },
                ],
                data: this.state.excelData,
            }
        ];
        return (

            <div>
                <Header as="h2"> <FormattedMessage id="poll.polls" /> </Header>
                <Segment.Group clearing raised >
                    <Segment> <Header as="h3"> <FormattedMessage id="poll.overview" /> </Header></Segment>

                    <Segment>
                        {this.state.loading ? <Loader active inline="centered" /> :
                            this.getDataToRender().length ? <Table celled selectable compact>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan={14} >
                                            <Grid column={2} stackable>
                                                <Grid.Column width={14}>
                                                    <SearchTableData profMozilla data={this.state.pollList} getResults={this.getResults} filterItem={['name']} />
                                                </Grid.Column>
                                                <Grid.Column width={2} textAlign="center">
                                                    <ExcelFile filename={'Spisak anketa'} element={<Popup
                                                        trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                            <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                            <Button.Content visible>
                                                                Excel
                                                            </Button.Content>
                                                        </Button>}
                                                        content="Preuzmi spisak u Excel-u"
                                                        hideOnScroll
                                                        position="top center"
                                                    />}>
                                                        <ExcelSheet dataSet={sanitizeExcelDataSet(multiDataSet)} name={'Ankete'} />
                                                    </ExcelFile>

                                                </Grid.Column>
                                            </Grid>
                                        </Table.HeaderCell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.HeaderCell width={1} >
                                            <FormattedMessage id="poll.index" />
                                        </Table.HeaderCell>
                                        <Table.HeaderCell colSpan={5}  >
                                            <FormattedMessage id="poll.title" />
                                        </Table.HeaderCell>
                                        <Table.HeaderCell colSpan={2} >
                                            <FormattedMessage id="poll.type" />
                                        </Table.HeaderCell>
                                        <Table.HeaderCell colSpan={2} >
                                            <FormattedMessage id="poll.startDateStudents" />
                                        </Table.HeaderCell>
                                        <Table.HeaderCell colSpan={2} >
                                            <FormattedMessage id="poll.endDate" />
                                        </Table.HeaderCell >


                                        <Table.HeaderCell colSpan={2} ></Table.HeaderCell>


                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {currentPosts.map((el, index) =>
                                        (<Table.Row
                                            key={index}
                                            onClick={(e) => {
                                                let poll = {
                                                    pollId: el.id,
                                                    pollName: el.name,
                                                    pollType: el.questionnaireType.id,
                                                    pollTypeKey: el.questionnaireType._key,
                                                    pollStatus: el.questionnaireStatus.id,
                                                    showAddQuestion: false
                                                };
                                                localStorage.setItem('poll', JSON.stringify(poll));
                                                this.setState({ showResults: true });
                                            }}
                                        >
                                            <Table.Cell width={1}  verticalAlign="middle">  {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}. </Table.Cell>
                                            <Table.Cell verticalAlign="middle" colSpan={5} >
                                                {el.name}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" colSpan={2} >
                                                {el.questionnaireType.name}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" colSpan={2} >
                                                {el.activationDate}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" colSpan={2} >
                                                {el.endDate}
                                            </Table.Cell>
                                            <Table.Cell verticalAlign="middle" textAlign="center" colSpan={2} >
                                                {/* link */}

                                                <Button
                                                    onClick={() => {
                                                        let poll = {
                                                            pollId: el.id,
                                                            pollName: el.name,
                                                            pollType: el.questionnaireType.id,
                                                            pollStatus: el.questionnaireStatus.id,
                                                            showAddQuestion: false
                                                        };
                                                        localStorage.setItem('poll', JSON.stringify(poll));
                                                        this.setState({ showResults: true });
                                                    }}

                                                    basic="true"
                                                    color="blue"
                                                    size="small"
                                                >  <FormattedMessage id="common.courses" />
                                                </Button>


                                            </Table.Cell>
                                        </Table.Row>))}
                                </Table.Body>
                            </Table> : 'Trenutno nema arhiviranih anketa.'
                        }
                        {currentPosts.length > 0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}
                    </Segment>

                </Segment.Group>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/Poll/ProfessorPoll/PollList.js